// extracted by LIB_CSS_EXTRACT_LOADER
import "./error-boundary_module.css"
export default {"fallback":"fallback-u_1nDW","title":"title-sC_d4o","message":"message-XHyoUA","retry":"retry-lwlF55"};